import React from "react";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-black text-gray-100 font-sans">
      <div className="container mx-auto px-6 py-16 max-w-4xl">
        <div className="border-l-4 border-teal-400 pl-6 mb-12">
          <h1 className="text-4xl font-bold text-white mb-3">Impressum</h1>
          <p className="text-gray-400 italic">Unternehmensangaben gemäß §5 TMG</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-10 bg-gray-900 bg-opacity-50 rounded-lg p-8 shadow-2xl">
          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-teal-400 mb-2">Unternehmen</h2>
              <p className="text-lg text-white">G-A-B-S GmbH</p>
              <p className="text-md text-white">HRB 44714 Registergericht Dresden</p>
              
            </div>
            
            <div>
              <h2 className="text-xl font-semibold text-teal-400 mb-2">Geschäftsführer</h2>
              <p className="text-lg text-white">Michael Pastrick</p>
            </div>
            
            <div>
              <h2 className="text-xl font-semibold text-teal-400 mb-2">USt-ID</h2>
              <p className="text-lg text-white">DE365646885</p>
            
            </div>
          </div>
          
          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-teal-400 mb-2">Anschrift</h2>
              <p className="text-lg text-white">Gabelsberger Str. 4</p>
              <p className="text-lg text-white">01809 Heidenau</p>
            </div>
            
            <div>
              <h2 className="text-xl font-semibold text-teal-400 mb-2">Kontakt</h2>
              <p className="text-lg text-white flex items-center">
                <span className="mr-2">☎</span> 03529-513372
              </p>
              <p className="text-lg text-white flex items-center">
                <span className="mr-2">✉</span> info@g-a-b-s.de
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} G-A-B-S GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </div>
  );
}